module.exports = __webpack_public_path__ + "img/cartao_cabal.daa6a265.png";